import YoutubeButton from "./YoutubeButton";
import { useTranslation } from "react-i18next";
import { ITutorialDataType } from "../pages/dashboard/lmc/types";
import { CustomButton } from "../atoms/CustomButton";

const LMCButtons = ({
  handleCancelEdit,
  tutorial,
}: {
  handleCancelEdit: () => void;
  tutorial?: ITutorialDataType | undefined;
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col sm:flex-row gap-3 mb-3 items-stretch sm:items-center justify-end">
      {tutorial && (
        <div className="sm:mr-auto">
          <YoutubeButton tutorial={tutorial} />
        </div>
      )}

      <CustomButton
        onClick={handleCancelEdit}
        variant="outline"
        title={t("common.cancel") as string}
        className="w-full sm:w-auto"
      />
      <CustomButton
        type="submit"
        variant="primary"
        title={t("common.saveShort") as string}
        className="w-full sm:w-auto"
      />
    </div>
  );
};

export default LMCButtons;
